import { Link } from 'react-router-dom';
import { Header } from '@/components/layout/Header';

export function PrivacyPage() {
  return (
    <div className="min-h-full bg-gray-50">
      <Header />
      <div className="max-w-3xl mx-auto p-6 bg-white">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Chính sách bảo mật</h1>
        <p className="text-sm text-gray-500 mb-6">Cập nhật: 06/2026</p>

        <div className="prose prose-sm max-w-none text-gray-700 space-y-4">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">1. Dữ liệu chúng tôi thu thập</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>Email + mật khẩu</strong> (đã hash bằng PBKDF2) — để đăng nhập</li>
              <li><strong>Tên hiển thị</strong> — để cá nhân hóa</li>
              <li><strong>Lịch sử thanh toán</strong> — giao dịch SePay (chỉ ID, không lưu thông tin thẻ)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">2. Dữ liệu KHÔNG thu thập</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Vị trí cá nhân của người dùng (chỉ xử lý click tạm thời để tra cứu)</li>
              <li>Thông tin thẻ ngân hàng (qua SePay)</li>
              <li>Cookies theo dõi bên thứ 3</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">3. Cách sử dụng dữ liệu</h2>
            <p>Chỉ dùng để cung cấp dịch vụ tra cứu. Không chia sẻ, bán, hoặc cho thuê dữ liệu cá nhân.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">4. Bảo mật</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Mật khẩu hash bằng PBKDF2 với 100,000 iterations + salt</li>
              <li>JWT với refresh token rotation, httpOnly cookies</li>
              <li>HTTPS bắt buộc (HSTS)</li>
              <li>Rate limiting 100 req/phút/IP</li>
              <li>Account lockout sau 5 lần đăng nhập sai</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-2">5. Quyền của bạn</h2>
            <p>Bạn có quyền yêu cầu xóa tài khoản và dữ liệu liên quan. Liên hệ: <a href="mailto:support@mymap.vn" className="text-brand-600">support@mymap.vn</a></p>
          </section>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <Link to="/" className="text-brand-600 hover:underline">← Về trang chủ</Link>
        </div>
      </div>
    </div>
  );
}
